import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyle = makeStyles((theme) => ({
    root: {
        margin: "40px 0px",
    },
    title: {
        fontSize: "1.5rem !important",
        fontWeight: "500 !important",
        marginBottom: "20px !important",
        textAlign: "center",
    },
}));

const CCBillPay = () => {
    const classes = useStyle();
    return (
        <div className={classes.root}>
            <Typography className={classes.title}>
                Terms & Conditions for <br/>
                “Credit Card Bill Pay”
            </Typography>

            <ol >
                <li>
                    ST PAY customers are eligible to pay Visa and Mastercard credit card bills issued by any scheduled commercial bank in Bangladesh through their ST PAY account.
                </li>
                <li>
                    Each ST PAY customer may avail this service multiple times by paying Visa/Mastercard credit card bills in Bangladesh Taka (BDT) via the ST PAY App, subject to applicable Bangladesh Bank regulations, ST PAY account limits, and limits imposed by the respective card issuing bank.
                </li>
                <li>
                    ST PAY does not impose any specific limit on the number of credit card bill payments; however, customers must strictly comply with the payment rules, cut-off times, billing cycles, and credit limits set by the respective card issuing bank.
                </li>
                <li>
                    To be eligible for this service, customers must maintain an active ST PAY account with a verified bank account status and sufficient balance.
                </li>
                <li>
                    Credit card bill payment requests submitted through ST PAY are forwarded to the respective card issuing bank for processing. Payment confirmation and status updates may take up to <strong>seven (7) working days</strong>, depending on the bank’s internal processing timelines. ST PAY does not control or guarantee the processing time of card issuing banks.
                </li>
                <li>
                    Charges are applicable for this service. To learn more about applicable fees, please visit  
                    <a className="mx-2 text-blue-600 text-[18px]" style={{fontWeight: "600", opacity: ".75", letterSpacing: "0.05px"}} href="https://stpay.net/terms-condition" target="_blank" rel="noreferrer"
                    >https://stpay.net/terms-condition
                    </a>. 
                    ST PAY reserves the right to revise fees and charges from time to time in accordance with applicable laws and regulations.
                </li>
                <li>
                    ST PAY acts solely as a <strong>Payment Service Provider (PSP)</strong> facilitating the transmission of payment instructions. Visa, Mastercard, and the respective card issuing banks are solely responsible for credit card billing, posting, reversals, interest, penalties, late fees, or disputes arising from credit card bill payments. ST PAY shall not be liable for:
                    <ul>
                        <li>Late payment fees or penalties imposed by the card issuing bank</li>
                        <li>Delays caused by bank processing, system downtime, or cut-off timing</li>
                        <li>Incorrect credit card details provided by the customer</li>
                    </ul>
                    In case of any billing discrepancies or penalties, customers must <strong>directly contact the respective card issuing bank</strong>.
                </li>
                <li>
                    ST PAY reserves the right to modify, amend, suspend, or discontinue this service or these Terms & Conditions, in whole or in part, at any time without prior notice.
                </li>
                <li>
                    Any decision taken by ST PAY regarding the operation, eligibility, suspension, or continuation of this service shall be at the sole discretion of ST PAY and shall be considered final, subject to applicable laws and regulations.
                </li>
                
                <br/>
            </ol>

            <style>{`
                ol {
                    margin-left: -10px;
                    text-align: justify;
                }

                ol li::marker {
                    font-weight: 600;
                }

                ol li {
                    padding-left: 15px;
                    margin-bottom: 10px;
                }
            `}</style>

        </div>
    );
};

export default CCBillPay;